<div class="loading-icon-wrapper" *ngIf="currentLoadingStatus">
  <div class="loader" ></div>
</div>
